import React, { Component } from "react";
import { connect } from "react-redux";
import { awardsTargetToggle } from "../../actions/awardsActions";
import _ from "lodash";
import VotingTargetToggle from "../debate/VotingTargetToggle";
import VotingUserResult from "../debate/VotingUserResult";

class List extends Component {
  checkVotingResult = (tev, uid) => {
    let yes = tev.yes || [];
    let no = tev.no || [];

    yes = yes.filter(someId => someId === uid);
    no = no.filter(someId => someId === uid);

    if (yes.length) return true;
    if (no.length) return false;
    return null;
  };

  list = (cCode, users, theAwards) => {
    const absent = theAwards.absent || [];
    return (
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">이름</th>
            <th scope="col">투표 대상</th>
            <th scope="col">투표 결과</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(users)
            .filter(([uid, user]) => user.currentClass === cCode)
            .sort(([uid1, user1], [uid2, user2]) =>
              user1.name < user2.name ? -1 : 1
            )
            .map(([uid, user], idx) => {
              // const result =
              return (
                <tr key={idx}>
                  <th scope="row">{idx + 1}</th>
                  <td> {user.name} </td>
                  <td>
                    <VotingTargetToggle
                      cCode={cCode}
                      uid={uid}
                      target={!absent.includes(uid)}
                      updateTarget={this.props.awardsTargetToggle}
                    />
                  </td>
                  <td>
                    {absent.includes(uid) ? (
                      "N/A"
                    ) : (
                      <VotingUserResult
                        result={this.checkVotingResult(theAwards, uid)}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    );
  };

  render() {
    const { cCode } = this.props.location.params;
    const { users } = this.props;
    const theAwards = this.props.awards[cCode] || {};
    return (
      <div className="row">
        <div className="col-12">{this.list(cCode, users, theAwards)}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
  location: state.location,
  awards: state.awards
});

export default connect(
  mapStateToProps,
  { awardsTargetToggle }
)(List);
